module.exports = __webpack_public_path__ + "static/media/test.59cd3ad6.svg";